
const ResumeApi = [
    {
        id: 1,
        category: "education",
        college: "NIT Warangal (2021 - 2024) ",
        title: "Masters of computer Application ",
        CGPA: "7.33",
        startDate: "10-2021",
        endDate: "06:2024",
        Location :"Telengana, Warangal"
    },
    {
        id: 1,
        category: "education",
        college: "Rajasthan University (2017 - 2020) ",
        title: "Bachelor's of computer Application ",
        CGPA: "73%",
        startDate: "06-2017",
        endDate: "06-2020",
        Location : "Jaipur, Rajasthan"
    },
   
    {
        id: 2,
        category: "education",
        college: "NIT Warangal (2021 - 2024) ",
        title: "Masters of computer Application ",
        CGPA: "7.33",
        startDate: "10-2021",
        endDate: "06:2024",
        Location :"Telengana, Warangal"
    },
    {
        id: 3,
        category: "experiance",
        company: "AurionPro Soluation Limited",
        Desgination: "System Support Engineer",
        Desc: " AurionPro is working under Rajasthan Government for the project of city surveillance (For providing security in All Over Rajasthan ) with collaboration of Rajasthan police Where my team With 5 member including me is responsible for Assets management where I am alone responsible for managing cameras and switches in all over Jaipur/Udaipur/Kota city almost 500+ cameras and switches",
        startDate: "01-2021",
        endDate: "09-2021",
        Location: "Jaipur, Rajasthan"
    },
    {
        id: 4,
        category: "experiance",
        company: "AurionPro Soluation Limited",
        Desgination: "System Support Engineer",
        Desc: " AurionPro is working under Rajasthan Government for the project of city surveillance (For providing security in All Over Rajasthan ) with collaboration of Rajasthan police Where my team With 5 member including me is responsible for Assets management where I am alone responsible for managing cameras and switches in all over Jaipur/Udaipur/Kota city almost 500+ cameras and switches",
        startDate: "01-2021",
        endDate: "09-2021",
        Location: "Jaipur, Rajasthan"
    },
    {
        id: 5,
        category: "experiance",
        company: "AurionPro Soluation Limited",
        Desgination: "System Support Engineer",
        Desc: " AurionPro is working under Rajasthan Government for the project of city surveillance (For providing security in All Over Rajasthan ) with collaboration of Rajasthan police Where my team With 5 member including me is responsible for Assets management where I am alone responsible for managing cameras and switches in all over Jaipur/Udaipur/Kota city almost 500+ cameras and switches",
        startDate: "01-2021",
        endDate: "09-2021",
        Location: "Jaipur, Rajasthan"
    }
  ]
  
  export default ResumeApi